
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CTASection } from "@/sections/CTASection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { PricingSection } from "@/sections/PricingSection";

const AiToFigma = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/AIToFigma"
        ogImage="/images/ai2figma-og-image.jpg"
      />

      <MagicianSection
        title={t("page/AIToFigma:title")}
        subtitle={t("page/AIToFigma:subtitle")}
        magicianLogoFile="ai"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/AIToFigma:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/ai-to-figma-example.png",
          alt: "Illustrator to Figma converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/AIToFigma:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/AIToFigma:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-ai-into-figma.jpg",
          alt: t("page/AIToFigma:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/AIToFigma:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/AIToFigma:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/AIToFigma:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/AIToFigma:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/AIToFigma:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/AIToFigma:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/AIToFigma:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          { iconType: "TV", text: t("section/conversion:badges.accuracy") },
        ]}
        elements={{
          from: {
            iconType: "AI",
            image: "/images/illustrator-preview.jpg",
            title: "Illustrator Demo Preview",
          },
          to: {
            iconType: "FIGMA",
            image: "/images/figma-illustrator-preview.jpg",
            title: "Figma Illustrator Import Demo Preview",
          },
        }}
      />
      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.aiToFigmaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default AiToFigma;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/ai-to-figma',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  